import { useState, useEffect, useContext, useMemo, useRef } from 'react';
import CompanyService from 'services/company2';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import ModalService from 'services/modal';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { ActionContext } from 'actions/context';
import { InfiniteLoader } from 'react-window-infinite-loader';
import { FixedSizeList as List } from 'react-window';
import Util from 'lib/util';

const styles = {
  paper: {
    margin: '10px',
    width: '90%'
  },
  title: {
    padding: '24px 24px 0'
  }
};

function StoreLocation(props) {
  const { companyCode, storeCode, onClose, open, classes } = props;
  const { dispatch } = useContext(ActionContext);
  const [totalNum, setTotalNum] = useState(0);

  const instant = useRef({
    isLoading: false,
    pageNum: 1,
    searchKey: '',
    locationItem: undefined,
    list: []
  });
  let self = instant.current;
  self.getStoreLocalList = function () {
    if (Util.isEmpty(companyCode, storeCode) || !open || self.isLoading) {
      return;
    }
    // console.log('getStoreLocalList', [self.pageNum, self.searchKey]);
    let opts = {
      pageNum: self.pageNum,
      pageSize: 10,
      status: [1],
      storeCode: storeCode,
      searchKey: self.searchKey
    };
    self.isLoading = true;
    CompanyService.getStoreLocationPageList(companyCode, opts).then(res => {
      self.isLoading = false;
      if (!Util.isEmpty(res)) {
        self.list = self.list.concat(res.list || []);
        self.pageNum += 1;
        setTotalNum(res.total);
      }
    });
  };

  self.showError = function (errorMsg) {
    ModalService.showError(errorMsg, dispatch);
  };

  // 初始化默认企业
  useEffect(() => {
    self.getStoreLocalList();
  }, [self, storeCode, open]);

  function ok() {
    close(self.locationItem);
  }

  function close(val) {
    self.list = [];
    self.pageNum = 1;
    self.searchKey = '';
    self.locationItem = undefined;
    setTotalNum(0);
    if (typeof onClose === 'function') {
      onClose(val);
    }
  }

  function searchKeyChange(e) {
    let val = e.target.value;
    self.searchKey = val;
    if (val === '') {
      search();
    }
  }

  function locationChange(item) {
    self.locationItem = item;
  }

  function search() {
    self.list = [];
    self.pageNum = 1;
    setTotalNum(0);
    self.getStoreLocalList();
  }

  function loadMoreItems() {
    if (self.list.length === totalNum && totalNum > 0) {
      return;
    }
    self.getStoreLocalList();
  }

  const isItemLoaded = index => {
    return index < self.list.length;
  };

  const itemsRendered = obj => {
    let visibleStopIndex = obj.visibleStopIndex;
    if (!isItemLoaded(visibleStopIndex) && self.list.length < totalNum) {
      loadMoreItems();
    }
  };

  const renderItem = ({ index, style }) => {
    let item = self.list[index];
    return (
      <div style={style}>
        {isItemLoaded(index) ? (
          <label
            style={{
              fontSize: '14px'
            }}
          >
            <input
              type="radio"
              name="locationCode"
              value={item.locationCode}
              onChange={() => locationChange(item)}
              className="mr5"
            />
            <span
              style={{
                verticalAlign: 'text-bottom'
              }}
            >
              {item.locationCode} - {item.locationName}
            </span>
          </label>
        ) : (
          'Loading...'
        )}
      </div>
    );
  };

  return (
    <Dialog
      classes={{ paper: classes.paper }}
      open={open}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle classes={{ root: classes.title }} id="form-dialog-title">
        选择库位
      </DialogTitle>
      <DialogContent style={{ paddingRight: '0' }}>
        <TextField
          style={{
            verticalAlign: 'bottom',
            width: '90%',
            marginTop: '0',
            paddingBottom: '10px'
          }}
          label="库位编码/名称"
          onChange={searchKeyChange}
          InputProps={{
            endAdornment: (
              <InputAdornment
                onClick={() => {
                  search();
                }}
              >
                <SearchIcon />
              </InputAdornment>
            )
          }}
          variant="standard"
        />

        <InfiniteLoader
          isItemLoaded={isItemLoaded}
          itemCount={totalNum}
          loadMoreRows={loadMoreItems}
        >
          {({ onRowsRendered, ref }) => (
            <List
              onItemsRendered={itemsRendered}
              ref={ref}
              height={300}
              itemCount={totalNum}
              itemSize={30}
              width={300}
            >
              {renderItem}
            </List>
          )}
        </InfiniteLoader>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={close}
          variant="contained"
          className="m-flex-item u-btn u-btn_line"
        >
          取消
        </Button>
        <Button
          onClick={ok}
          variant="contained"
          color="primary"
          className="m-flex-item u-btn u-btn_primary"
        >
          确认
        </Button>
      </DialogActions>
    </Dialog>
  );
}

StoreLocation.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string
};

export default withStyles(styles)(StoreLocation);
